import { render, staticRenderFns } from "./CmgMealBuilderItemSelectorCard.vue?vue&type=template&id=4f6590ab&scoped=true&lang=pug"
import script from "./cmg-meal-builder-item-selector-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-meal-builder-item-selector-card.ts?vue&type=script&lang=ts&external"
import style0 from "./cmg-meal-builder-item-selector-card.scss?vue&type=style&index=0&id=4f6590ab&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6590ab",
  null
  
)

export default component.exports